module.exports = __webpack_public_path__ + "static/media/nft-art-icon1.5db1f3fd.svg";